import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { CommonPackageCreationFiltering, CommonPackageAddEdit } from './Pages';

export const CommonPackageCreationRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CommonPackageCreationFiltering} />
        <Route exact path={`${match.path}/AddEdit`} component={CommonPackageAddEdit} />
    </Fragment>
)